import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { Color, Size } from '../../../../../../const'
import { Button } from '../../../../../shard'
import { Link } from 'react-router-dom'

import { useAccountHook } from '../../../../../../hooks'

function AccountEditComplete() {
  const { axios, user, setUser } = useAccountHook()

  if (_.isEmpty(user)) axios.getUser().then(setUser)

  if (!_.isEmpty(user.data)) {
    return <AccountEditCompleteDisplay user={user.data}></AccountEditCompleteDisplay>
  } else {
    return <div></div>
  }
}

function AccountEditCompleteDisplay({ user }) {
  return (
    <AccountBlock>
      <Message>以下の内容で変更しました。</Message>
      <Separator />
      <TextArea>
        <NameLabel>氏名</NameLabel>
        <NameArea>
          <NameWrapper>
            <Name>
              {user.lastname} {user.firstname}
              <br />
              <Kana>
                {user.lastname_kana} {user.firstname_kana}
              </Kana>
            </Name>
          </NameWrapper>
        </NameArea>
        <GenderLabel>性別</GenderLabel>
        <Gender>{user.gender}</Gender>
        <BirthLabel>生年月日</BirthLabel>
        <Birth>
          {user.birthday_year}年{user.birthday_month}月{user.birthday_day}日
        </Birth>
        <EmailLabel>メールアドレス</EmailLabel>
        <Email>
          {user.mail}@{user.maildomain}
        </Email>
        <TellLabel>連絡先</TellLabel>
        <Tell>{user.phone}</Tell>
        <AddressLabel>住所</AddressLabel>
        <Address>
          〒{user.addresses.address1.zipcode}
          <br />
          {user.addresses.address1.state}
          {user.addresses.address1.city}
          {user.addresses.address1.address1}
          {user.addresses.address1.address2}
          {user.addresses.address1.address3}
        </Address>
      </TextArea>
      <Separator />
      <ButtonWrapper>
        <Link to="/account">
          <Button primary type="button">
            アカウント情報へ戻る
          </Button>
        </Link>
      </ButtonWrapper>
    </AccountBlock>
  )
}

const AccountBlock = styled.div``
const Message = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  padding: 22px 0;
  text-align: center;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`
const TextLabel = `
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
  padding-bottom: 15px;
`
const Text = `
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  padding-bottom: 30px;
`
const TextArea = styled.div`
  padding: 19px 20px 25px 20px;
`
const NameLabel = styled.div`
  ${TextLabel}
`
const NameArea = styled.div`
  ${Text}
`
const NameWrapper = styled.div``
const Name = styled.div``
const Kana = styled.span`
  color: ${Color.FONT.ANNOTATION};
  font-size: ${Size.FONT.REGULAR};
`
const GenderLabel = styled.div`
  ${TextLabel}
`
const Gender = styled.div`
  ${Text}
`
const BirthLabel = styled.div`
  ${TextLabel}
`
const Birth = styled.div`
  ${Text}
`
const EmailLabel = styled.div`
  ${TextLabel}
`
const Email = styled.div`
  ${Text}
`
const TellLabel = styled.div`
  ${TextLabel}
`
const Tell = styled.div`
  ${Text}
`
const AddressLabel = styled.div`
  ${TextLabel}
`
const Address = styled.div`
  ${Text}
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`

export default AccountEditComplete
